import React, { useEffect, useRef, useState } from "react";
import {
  Dropdown,
  InputField,
  Modal,
  SearchInput,
  TextComponent,
} from "../../../../components";
import styles from "./editAsset.module.css";
import { Checkbox, List } from "antd";
import { PiSealCheck } from "react-icons/pi";
import { TbDeviceRemote } from "react-icons/tb";
import { FaSquarePlus } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import uploadPicture from "../../../../assets/images/uploadPicture.png";
import { AssetsMiddleware } from "../../../../Store/Middlewares/AssetsMiddleware";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { CusAssetsMiddleware } from "../../../../Store/Middlewares/CusAssetsMiddleware";

const EditAssets = ({
  isOpen,
  setIsOpen,
  details,
  afterDispatch,
  from,
  setDrawerState,
}) => {
  const dispatch = useDispatch();
  const [success, setSuccess] = useState(false);
  const [id, setId] = useState(details?.id);
  const [name, setname] = useState(details?.name || "");
  const [make, setmake] = useState(details?.make || "");
  const [model, setmodel] = useState(details?.model || "");
  const [vinNo, setvinNo] = useState(details?.vin_no || "");
  const [licenseNo, setlicenseNo] = useState(details?.license_no || "");
  const [deviceId, setdeviceId] = useState(details?.device_id || "");
  const [deviceName, setdeviceName] = useState(details?.device_name || "");
  const [batteryVolt, setbatteryVolt] = useState(details?.battery_volt || "");
  const [assetImage, setassetImage] = useState(null);
  const [trim, setTrim] = useState("");
  const [color, setColor] = useState("");
  const [stock, setstock] = useState("");
  const [year, setYear] = useState("");
  const [lot_no, setLot_no] = useState({ value: "", id: "" });

  const lot_numbers = useSelector((state) => state.PagesReducer?.lot_numbers);
  // const imgRef = useRef();
  const uploadimageid = document.getElementById("upload");

  useEffect(() => {
    // setIsOpen(true)

    if (isOpen && details) {
      setname(details?.name || "");
      setmake(details?.make || "");
      setmodel(details?.model || "");
      setvinNo(details?.vin_no || "");
      setlicenseNo(details?.license_no || "");
      setdeviceId(details?.device_id || "");
      setdeviceName(details?.device_name || "");
      setbatteryVolt(details?.battery_volt || "");
      setTrim(details.trim || "");
      setColor(details.color || "");
      setId(details?.id);
      setstock(details?.stock_no || "");
      setYear(details?.year || "");
      setLot_no(
        details?.lot_no
          ? { value: details.lot_no, id: "" }
          : { value: "", id: "" },
      );
    }
  }, [isOpen, details]);

  const onUpdateAssets = () => {
    let userData = {
      id,
      name,
      make,
      model,
      vinNo,
      licenseNo,
      deviceId,
      deviceName,
      assetImage: assetImage ? assetImage : null,
      batteryVolt,
      trim,
      color,
      stock,
      year,
      lot_no: lot_no?.id,
    };
    if (
      // !name ||
      // !make ||
      // !model ||
      !vinNo
      // ||
      // !stock
    ) {
      dispatch(
        showAlert({ type: "Error", message: "All fields are required" }),
      );
    }
    //  else if (!deviceId) {
    //   dispatch(
    //     showAlert({
    //       type: "Error",
    //       message: "Please enter Device id given by merchant!",
    //     }),
    //   );
    // }
    else if (batteryVolt > 12) {
      dispatch(
        showAlert({
          type: "Error",
          message: "Battery volt should be less than 12V",
        }),
      );
    } else {
      if (from == "customer") {
        dispatch(CusAssetsMiddleware.UpdateCusAssets(userData))
          .then((data) => {
            setIsOpen(false);
            setassetImage(null);
            setdeviceId("");
            setdeviceName("");
            setlicenseNo("");
            setmake("");
            setmodel("");
            setname("");
            setvinNo("");
            setbatteryVolt("");
            setDrawerState(false);
            setTrim("");
            setColor("");
            setstock("");
            setYear("");
            setLot_no("");
            uploadimageid.value = "";
          })
          .catch(() => {});
      } else {
        dispatch(AssetsMiddleware.updateAssets(userData))
          .then((data) => {
            setIsOpen(false);
            setSuccess(true);
            setassetImage(null);
            setdeviceId("");
            setdeviceName("");
            setlicenseNo("");
            setmake("");
            setmodel("");
            setname("");
            setvinNo("");
            setbatteryVolt("");
            setDrawerState(false);
            afterDispatch(false);
            setTrim("");
            setColor("");
            setstock("");
            setYear("");
            setLot_no("");
            uploadimageid.value = "";
          })
          .catch(() => {});
      }
    }
  };
  return (
    <>
      <Modal
        open={isOpen}
        onCancel={() => setIsOpen(false)}
        width={"800px"}
        twoButton
        okBtnTitle={"Save Information"}
        cancelBtnTitle={"Go back"}
        btnDiv={styles.access_modalBtn}
        onClickCancelButton={() => {
          setIsOpen(false);
        }}
        onClickOkButton={
          onUpdateAssets
          // ()=>{setIsOpen(false); setSuccess(true)}
        }
        btnStyle={{ width: "80%" }}
        // headingClass={styles.modalHeading}
      >
        <div className={styles.mainCont}>
          <TextComponent
            text={"Setup Vehicle Information"}
            className={styles.heading}
          />
          <TextComponent
            text={"Please provide detailed information about your vehicle."}
            // className={styles.heading}
          />
          <div className={styles.formDivideDiv}>
            <div className={styles.formDivideInput}>
              <img
                className={styles.slectImg}
                onClick={() => uploadimageid?.click()}
                src={
                  assetImage
                    ? URL.createObjectURL(assetImage)
                    : details?.image
                      ? details?.image
                      : uploadPicture
                }
                alt=""
              />
              <input
                type="file"
                id="upload"
                accept="image/*"
                style={{ display: "none" }}
                // ref={imgRef}
                onChange={(e) => setassetImage(e.target.files[0])}
              />
            </div>
            <div className={styles.formDivideInput}>
              <InputField
                label={"Name"}
                placeholder={"Write here"}
                value={name}
                onChange={(e) => setname(e.target.value)}
              />
              <InputField
                label={"Make"}
                placeholder={"Write here"}
                value={make}
                onChange={(e) => setmake(e.target.value)}
              />
            </div>
          </div>
          <div className={styles.formDivideDiv}>
            <InputField
              label={"Model"}
              placeholder={"Write here"}
              value={model}
              className={styles.formDivideInput}
              onChange={(e) => setmodel(e.target.value)}
            />
            {/* <Dropdown
              className={styles.formDivideInput}
              label={"Lot Name"}
              value={lot_no}
              labelStyle={{ color: "#838383", fontSize: 18 }}
              style={{ color: "black" }}
              options={lot_numbers?.map((lot) => ({
                value: lot?.name,
                id: lot?.id,
              }))}
              onChange={(e) => setLot_no(e)}
            /> */}
          </div>
          <div className={styles.formDivideDiv}>
            <InputField
              label={"VIN (Vehicle Identification Number)"}
              className={styles.formDivideInput}
              placeholder={"Write here"}
              value={vinNo}
              onChange={(e) => setvinNo(e.target.value)}
              maxLength={17}
            />
            <InputField
              label={"License Plate Number(Optional)"}
              className={styles.formDivideInput}
              placeholder={"Write here"}
              value={licenseNo}
              onChange={(e) => setlicenseNo(e.target.value)}
              maxLength={8}
            />
          </div>
          <div className={styles.formDivideDiv}>
            <InputField
              label={"Trim"}
              className={styles.formDivideInput}
              placeholder={"Write here"}
              value={trim}
              onChange={(e) => setTrim(e.target.value)}
            />
            <InputField
              label={"Color"}
              className={styles.formDivideInput}
              placeholder={"Write here"}
              value={color}
              onChange={(e) => setColor(e.target.value)}
            />
          </div>
          <div className={styles.formDivideDiv}>
            {/* <InputField
              label={"Device Name"}
              className={styles.formDivideInput}
              placeholder={"Write here"}
              value={deviceName}
              onChange={(e) => setdeviceName(e.target.value)}
            /> */}
            <InputField
              label={"Device ID"}
              className={styles.formDivideInput}
              placeholder={"Write here"}
              value={deviceId}
              onChange={(e) => setdeviceId(e.target.value)}
            />
            <InputField
              label={"Stock"}
              className={styles.formDivideInput}
              placeholder={"Write here"}
              value={stock}
              onChange={(e) => setstock(e.target.value)}
            />
          </div>
          <div className={styles.formDivideDiv}>
            {/* <InputField
              // type={"number"}
              label={"Vehicle Battery Voltage(Optional)"}
              placeholder={"Write here"}
              value={batteryVolt}
              className={styles.formDivideInput}
              onChange={(e) => setbatteryVolt(e.target.value)}
            /> */}
            <InputField
              type={"number"}
              label={"Year"}
              placeholder={"Write here"}
              className={styles.formDivideInput}
              value={year}
              onChange={(e) => setYear(e.target.value)}
            />
          </div>
          {/* <InputField 
          label={"Location tag"}
          />
          <Dropdown
            className={styles.input}
            label={"Module"}
            placeholder={"Select module"}
            labelStyle={{ color: "#838383", fontSize: 18 }}
            style={{ color: "black" }}
            options={[
              {
                value: "Module 1",
                id: 1,
              },
              {
                value: "Module 2",
                id: 2,
              },
            ]}
            // onChange={(e) => setRole(e)}
          /> */}
          {/* <Checkbox className={styles.check} onChange={onChange}>
            Enable geofencing and location tracking for added security
          </Checkbox> */}
        </div>
      </Modal>
      <Modal
        open={success}
        onCancel={() => setSuccess(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Vehicle Edited Successfully"}
        width={"400px"}
        buttonTitle={"Go back"}
        onBtnPress={() => {
          setSuccess(false);
        }}
        headingClass={styles.modalHeading}
      ></Modal>
    </>
  );
};
{
  /* <Modal
  open={success}
  onCancel={() => setSuccess(false)}
  icon={
    <PiSealCheck
      style={{ width: "100%", height: "100%", objectFit: "contain" }}
    />
  }
  title={"Asset Edited Successfully"}
  width={"400px"}
  buttonTitle={"Go back"}
  onBtnPress={() => {
    setSuccess(false);
  }}
  headingClass={styles.modalHeading}
></Modal> */
}

export default EditAssets;
